import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { UpdateUnverifiedPhotographerAPI } from "../../../../utils/APIs/photographersApis";
import Loader from "../../../../Loader/Loader";

const EditPhotographerModal = ({ isOpen, onClose, onEdit, photographer }) => {

    console.log("Photograpaher",photographer)

  const[loading,setLoading]=useState(false)
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    experience: "",
    city: "",
    signupDate: "",
    photographerType: "",
  });

 useEffect(() => {
  if (photographer) {

    const formatToInputDate = (dateString) => {
      if (!dateString) return "";

      // If already in YYYY-MM-DD format
      if (dateString.includes("-")) return dateString;

      // Convert DD/MM/YYYY → YYYY-MM-DD
      const [day, month, year] = dateString.split("/");
      return `${year}-${month}-${day}`;
    };

    setFormData({
      name: photographer.name || "",
      email: photographer.email || "",
      phone: photographer.phone || "",
      experience: photographer.experience || "",
      city: photographer.city || "",
      signupDate: formatToInputDate(photographer.signUpDate),
      photographerType: photographer.photographerType || "",
    });
  }
}, [photographer]);



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const convertBackToDDMMYYYY = (dateString) => {
  if (!dateString) return "";
  const [year, month, day] = dateString.split("-");
  return `${day}/${month}/${year}`;
};


  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  const payload = {
    name: formData.name,
    email: formData.email,
    phone: formData.phone,
    experience: formData.experience,
    city: formData.city,
    signUpDate: convertBackToDDMMYYYY(formData.signupDate),
    photographerType: formData.photographerType,
  };

  try {
    const res = await UpdateUnverifiedPhotographerAPI(
    photographer._id,
    payload
  );

    console.log("Photographer added:", res?.data);

    // optional: update parent list immediately
    if(res?.data?.success){
      toast.success(res?.data?.message);
      if (onEdit && res?.data?.photographer) {
      onEdit(res.data.photographer);
      setFormData({
      name: "",
      email: "",
      phone: "",
      experience: "",
      city: "",
      signupDate: "",
      photographerType: "",
    });

    onClose();

     }
}

    
    else{
      toast.error(res?.data?.message)
    }

    }
    
        
   catch (error) {
    console.error("Failed to add photographer:", error);
    alert(
      error?.response?.data?.message || "Failed to Update photographer"
    );
  } finally {
    setLoading(false);
  }
};


  if (!isOpen) return null;

  if(loading){
    return<Loader/>
  }

  return (
    <div className="photographer-modal-overlay">
      <div className="photographer-add-modal-content">
        <h2>Update Photographer</h2>
        <form onSubmit={handleSubmit} className="add-form">
          <label>
            Name:
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Email:
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Phone:
            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Experience:
            <input
              type="text"
              name="experience"
              value={formData.experience}
              onChange={handleChange}
            />
          </label>

          <label>
            City:
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
            />
          </label>

          <label>
            Sign-Up Date:
            <input
              type="date" onClick={(e) => { if(e.target.showPicker) e.target.showPicker(); }}
              name="signupDate"
              value={formData.signupDate}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Photographer Type:
            <select
              name="photographerType"
              value={formData.photographerType}
              onChange={handleChange}
              required
            >
              <option value="">Select Type</option>
              <option value="Photographer">Photographer</option>
              <option value="Videographer">Videographer</option>
              <option value="Editor">Editor</option>
              <option value="Lighting Setup">Lighting Setup</option>
            </select>
          </label>

          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn-add">
              Update
            </button>
            
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPhotographerModal;
